import React from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { PAGE_TYPES } from '@sparefoot/tracking-events';
import { withExperiment } from '@sparefoot/react-core/decorators';

import { withPageViewTracking } from 'components/core/library/tracking-utils';
import { Page } from 'components/core/Page';

import { HomePageHero } from 'components/landing/HomePageHero';
import { HowItWorksSection } from 'components/brand/HowItWorksSection';
import { StorageTypesSection } from 'components/brand/StorageTypesSection';
import { SizeGuideSection } from 'components/brand/SizeGuideSection';
import { ReviewSection } from 'components/brand/ReviewSection';
import { FeaturedCitiesSection } from 'components/brand/FeaturedCitiesSection';
import { PLPFacilitiesSection } from 'components/plp/PLPFacilitiesSection';

import './homepage.scss';


export const enhance = compose(
	connect(({ content, app }) => ({
		featuredCities: content.featuredCities,
		baseUrl: app.baseUrl
	})),
	withExperiment('sf_15342_geolocation_sfdc'),
	withPageViewTracking(PAGE_TYPES.HOME_PAGE)
);

export function HomePage({ featuredCities, baseUrl, sf15342Variation }) {
	return (
		<Page
			className="homepage"
			pageType={PAGE_TYPES.HOME}
			landingPage
		>
			<Helmet>
				<meta
					name="msvalidate.01"
					content="72430AA401040F456AF99A586F12B284"
				/>
				<link
					rel="canonical"
					href={baseUrl}
				/>
				<script type="application/ld+json">
					{`
						{
							"@context": "http://schema.org",
							"@type": "WebSite",
							"url": "https://www.sparefoot.com",
							"potentialAction": {
								"@type": "SearchAction",
								"target": "https://www.sparefoot.com/search?location={search_term_string}",
								"query-input": "required name=search_term_string"
							}
						}
					`}
				</script>
				<script type="application/ld+json">
					{`
						{
							"name": "Sparefoot",
							"@context": "http://schema.org",
							"@type": ["Organization", "OnlineBusiness"],
							"url": "https://www.sparefoot.com",
							"logo": "https://www.sparefoot.com/logo.svg",
							"sameAs": [
								"https://twitter.com/SpareFoot",
								"https://www.facebook.com/SpareFoot",
								"https://www.instagram.com/sparefoot/",
								"https://www.pinterest.com/sparefoot/"
							],
							"contactPoint": [
								{
								"@type": "ContactPoint",
								"telephone": "+1-512-705-6208",
								"contactType": "customer service"
								}
							],
							"founder": "Chuck Gordon",
							"foundingDate": 2008
						}
					`}
				</script>
			</Helmet >
			<HomePageHero />
			{ sf15342Variation === 'variation1' && ( // sf_15342_geolocation_sfdc
				<PLPFacilitiesSection />
			)}
			<HowItWorksSection />
			<SizeGuideSection />
			<StorageTypesSection />
			<ReviewSection />
			{!isEmpty(featuredCities) && (
				<FeaturedCitiesSection
					cities={featuredCities}
					fillOrder="vertical"
				/>
			)}
		</Page>
	);
}

HomePage.propTypes = {
	featuredCities: PropTypes.arrayOf(PropTypes.object).isRequired,
	baseUrl: PropTypes.string
};

export default enhance(HomePage);
